import React, { createContext, useContext, useEffect, useState, ReactNode } from 'react';
import { useContentMetafieldData } from '@jbhi-fi/components/src/hooks/useContentMetafieldData/useContentMetafieldData';
import { UseContentProps } from '@jbhi-fi/components/src/types';
import { SubCategoryProps } from '../../views/SubCategory/SubCategory';
import { contentfulApiSubCategoryPageToSubCategoryProps } from '../../transformers/contentfulApiSubCategoryPageToSubCategoryProps';
import { ContentfulSubCategoryPage, EntryType } from '@jbhi-fi/apis/src/contentful/types';
import { useContentfulEntries } from '@jbhi-fi/components/src/hooks/useContentfulEntries/useContentfulEntries';

export const SubCategoryPropsContext = createContext<UseContentProps<SubCategoryProps> | null>(null);

export const SubCategoryPropsProvider = ({ children }: { children: ReactNode }) => {
  const metafieldData = useContentMetafieldData<ContentfulSubCategoryPage>();

  const { entries, isLoading, error } = useContentfulEntries<ContentfulSubCategoryPage>({
    filter: {
      content_type: EntryType.subCategory,
      'sys.id': metafieldData.sys.id,
    },
    autoRefresh: window.Jbhifi.isContentPreview,
  });

  const data = entries?.length && entries[0];
  const [subCategoryProps, setSubCategoryProps] = useState<SubCategoryProps>(
    contentfulApiSubCategoryPageToSubCategoryProps(metafieldData)
  );

  useEffect(() => {
    setSubCategoryProps(contentfulApiSubCategoryPageToSubCategoryProps(data || metafieldData));
  }, [data]);

  return !subCategoryProps?.cardsFilter ? null : (
    <SubCategoryPropsContext.Provider value={{ data: subCategoryProps, isLoading, error }}>
      {children}
    </SubCategoryPropsContext.Provider>
  );
};

export const useSubCategoryProps = (): UseContentProps<SubCategoryProps> | null => {
  const context = useContext(SubCategoryPropsContext);
  if (context === undefined || context === null) {
    throw new Error('useSubCategoryProps must be used within a SubCategoryPropsProvider');
  }

  return context;
};
